/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';


module.exports = {
    /**
     * Convert bytes to human readable text value (GB/MB/KB/B)
     * @param {number} size file size in bytes
     * @return {string} size localised size
     */
    convert: function ( size ) {
        if ( !size || size < 0 ) { return 'n/a'; }

        if ( size > (1024 * 1024 * 1024) ) {
            return (Math.floor(size / 1024 / 1024 / 1024 * 100) / 100) + ' ' + gettext('GB');
        }
        if ( size > (1024 * 1024) ) {
            return (Math.floor(size / 1024 / 1024 * 100) / 100) + ' ' + gettext('MB');
        }
        if ( size > (1024) ) {
            return (Math.floor(size / 1024 * 100) / 100) + ' ' + gettext('KB');
        }

        return size + ' ' + gettext('B');
    },
    /**
     * Get file size by url
     * @param {string} url path to file
     * @param {function} callback callback file size in bytes
     */
    checkSize: function ( url, callback ) {
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if ( xhr.readyState === 4 ) {
                if ( typeof callback === 'function' ) {
                    // debug.log('AJAX->answered, Length:' + xhr.getResponseHeader('Content-Length'));
                    callback(xhr.getResponseHeader('Content-Length'));
                }
            }
        };
        xhr.open('HEAD', url, true);
        xhr.send(null);
    }
};
